import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import colors from './constants/colors';
import SVGIcon from './SVGIcon';

const Button = styled.button`
  align-items: center;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  display: inline-flex;
  font-size: 14px;
  justify-content: center;
  margin: 0;
  padding: 10px 20px;
  position: relative;
  transition: all 0.125s ease-out;
  z-index: 2;
  text-transform: uppercase;
  min-height: 24px;

  ${SVGIcon} {
    transition: all 0.125s ease-out;
  }

  ${props =>
    props.styleType === 'primary' &&
    css`
      color: ${colors.white};
      background: ${colors.electricBlue};

      ${SVGIcon} {
        fill: ${colors.white};
      }

      &:hover,
      &:focus {
        background: ${colors.midnightBlue};
      }
    `}

  ${props =>
    props.styleType === 'secondary' &&
    css`
      color: ${colors.eerieBlack};
      background: transparent;
      border: 2px solid ${colors.eerieBlack};

      ${SVGIcon} {
        fill: ${colors.eerieBlack};
      }

      &:hover,
      &:focus {
        background: ${colors.eerieBlack};
        color: ${colors.white};

        ${SVGIcon} {
          fill: ${colors.white};
        }
      }
    `}

  ${props =>
    props.styleType === 'subtle' &&
    css`
      color: ${colors.eerieBlack};
      background: transparent;

      ${SVGIcon} {
        fill: ${colors.eerieBlack};
      }

      &:hover,
      &:focus {
        color: ${colors.eerieBlack};

        ${SVGIcon} {
          fill: ${colors.eerieBlack};
        }
      }
    `}

  ${props =>
    (props.styleType === 'disabled' || props.disabled) &&
    css`
      color: ${colors.white};
      background: ${colors.littleDipper};
      cursor: not-allowed;

      ${SVGIcon} {
        fill: ${colors.white};
      }

      &:hover,
      &:focus {
        color: ${colors.white};
        background: ${colors.littleDipper};
      }
    `}

  svg {
    margin-left: 1rem;
  }
`;

Button.propTypes = {
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  styleType: PropTypes.string,
};

Button.defaultProps = {
  disabled: false,
  errorMessage: '',
  styleType: 'primary',
};

export default Button;
